module.exports = __webpack_public_path__ + "static/img/萌星闪闪- banner.d150210.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listitem/萌星闪闪- banner.png
// module id = 831
// module chunks = 0